import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { AppState } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { GetMainSectionFn } from '../custom-topic-routes'
import { olympicsCurationSegment } from './olympics-segment'

export const getOlympicRouteInfo: (state: AppState) => GetMainSectionFn =
    (state) => () => {
        return [
            olympicsCurationSegment({
                isWidgetFallbackEnabled: isFeatureEnabled(
                    toFeatureState(state.toggles),
                    'tokyo-medal-widget-fallback',
                ),
            }),
            ...billboardLeaderboardMrec('one'),
            layout.component({
                type: 'lima',
                props: {
                    loadMoreEnabled: true,
                    verticalSpacing: 'xl',
                    fontScale: 1.2,
                    fixedRatios: ['16:9'],
                    hasBackground: true,
                    teaserMode: {
                        initial: 'visible',
                        xs: 'visible',
                        sm: 'hidden',
                        md: 'hidden',
                    },
                    initialColumns: 1,
                    intermediateColumns: 2,
                    finalColumns: 4,
                    cardOrientation: { type: 'Landscape-Portrait' },

                    sectionHeader: {
                        heading: 'Latest Olympic News',
                        headingUrl: '/sport/olympics',
                        section: 'sport',
                    },
                    dataDefinitionArgs: {
                        type: 'listing',
                        topics: ['sport/olympics'],

                        includeSubTopics: false,
                        paging: {
                            page: 1,
                            pageSize: 8,
                        },
                    },
                },
            }),
            ...billboardLeaderboardMrec('two'),
        ]
    }

export const getOlympicTopicRouteInfo: GetMainSectionFn = () => {
    return [
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: {
                    initial: 'visible',
                    xs: 'visible',
                    sm: 'hidden',
                    md: 'hidden',
                },
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/olympics'],

                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('one'),
        layout.component({
            type: 'lima',
            props: {
                loadMoreEnabled: true,
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: {
                    initial: 'visible',
                    xs: 'visible',
                    sm: 'hidden',
                    md: 'hidden',
                },
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/olympics'],

                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                        pageOffset: 8,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('two'),
    ]
}
